<script setup>
  import { ref, defineProps, defineEmits } from 'vue'
  import { probeSubscription } from '@/api/registrationSubscription'

  const props = defineProps({
    meetingCode: { type: String, required: true },
    subscription: { type: Object, required: true },
  })
  const emit = defineEmits(['close'])
  const running = ref(false)
  const result = ref(null)
  const failed = ref(false)
  const stages = {
    PREPARATION: '加密与签名',
    ADDRESS: '地址与DNS',
    TLS: 'TLS证书',
    CONNECTION: '网络连接',
    TIMEOUT: '连接或响应超时',
    HTTP: 'HTTP响应',
    ACK: '业务确认',
  }
  async function run() {
    if (running.value) return
    running.value = true
    result.value = null
    failed.value = false
    try {
      const { data } = await probeSubscription(props.meetingCode, props.subscription.id)
      result.value = data
    } catch (error) {
      failed.value = true
    } finally {
      running.value = false
    }
  }
</script>

<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="!running"
    :model-value="true"
    :show-close="!running"
    title="测试连通性"
    width="620px"
    @close="emit('close')"
  >
    <el-descriptions border :column="1">
      <el-descriptions-item label="接收方">{{ subscription.receiverName }}</el-descriptions-item>
      <el-descriptions-item label="回调地址">
        <span class="callback">{{ subscription.callbackUrl }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="订阅状态">{{ subscription.enabled ? '启用' : '停用' }}</el-descriptions-item>
    </el-descriptions>
    <p>发送一条加密、签名的模拟请求，不启用订阅，不自动重试。</p>
    <el-alert v-if="failed" :closable="false" title="测试请求失败或超时，请重试并检查服务日志" type="error" />
    <template v-if="result">
      <el-alert :closable="false" :title="result.message" :type="result.success ? 'success' : 'error'" />
      <el-descriptions border class="result" :column="2">
        <el-descriptions-item label="检测阶段">{{ stages[result.stage] || result.stage }}</el-descriptions-item>
        <el-descriptions-item label="耗时">{{ result.durationMs }} ms</el-descriptions-item>
        <el-descriptions-item label="HTTP状态">{{ result.httpStatus || '—' }}</el-descriptions-item>
        <el-descriptions-item label="事件ID">{{ result.eventId }}</el-descriptions-item>
      </el-descriptions>
    </template>
    <template #footer>
      <el-button :disabled="running" @click="emit('close')">关闭</el-button>
      <el-button :loading="running" type="primary" @click="run">
        {{ result || failed ? '重新测试' : '开始测试' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<style scoped>
  .callback {
    word-break: break-all;
  }
  .result {
    margin-top: 16px;
  }
</style>
